import get from 'lodash/get';
import classNames from 'classnames';
import React, {Component} from 'react';
import {FastField} from 'formik';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import {generateNextChoiceId} from '../../../services/idHelpers';
import MinusButton from './MinusButton';
import UpButton from './UpButton';
import DownButton from './DownButton';
import DraggableCell from './DraggableCell';
import DraggableRow from './DraggableRow';
import DragDropTableBody from './DragDropTableBody';
import Error from '../../Error';
import TooltipIcon from '../../TooltipIcon';
import MediaGalleryModal from '../../media/MediaGalleryModal';

class ImageChoiceType extends Component {
    constructor(props) {
        super(props);
        this.state = {modalOpen: false};
        this.toggleModal = this.toggleModal.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.toggleShuffle = this.toggleShuffle.bind(this);
    }

    toggleModal() {
        this.setState((s) => ({modalOpen: !s.modalOpen}));
    }

    handleSelect({assetId, url}) {
        const choices = get(this.props.form.values, this.props.name);
        this.props.push({id: generateNextChoiceId(choices), value: '', url, assetId, shuffle: false});
    }

    toggleShuffle() {
        const {replace, form, name} = this.props;
        const items = get(form.values, name) || [];
        const value = !items.every(({shuffle}) => shuffle);
        items.forEach((item, index) => {
            replace(index, Object.assign({}, item, {shuffle: value}));
        });
    }

    render() {
        const {remove, move, form, name} = this.props;

        const items = get(form.values, name) || [];

        return (
            <table className="table table-sm table-borderless">
                <colgroup>
                    <col style={{width: 120}} />
                    <col />
                    <col style={{width: 150}} />
                    <col style={{width: 110}} />
                    <col style={{width: 80}} />
                </colgroup>
                <thead>
                    <tr>
                        <th className="pl-0"><FormattedMessage {...messages.surveys.form.label.choiceId} /></th>
                        <th><FormattedMessage {...messages.surveys.form.label.choiceLabel} /></th>
                        <th><FormattedMessage {...messages.surveys.form.label.image} /></th>
                        <th>
                            <div className="custom-control custom-checkbox">
                                <input className="custom-control-input" type="checkbox"
                                    checked={items.every(({shuffle}) => shuffle)} onChange={this.toggleShuffle} id={`${name}.shuffledToggle`} />
                                <label className="custom-control-label" htmlFor={`${name}.shuffledToggle`}>
                                    <FormattedMessage {...messages.surveys.form.label.shuffled} />
                                    {' '}
                                    <TooltipIcon message={messages.surveys.form.tooltip.shuffled} />
                                </label>
                            </div>
                        </th>
                        <th />
                    </tr>
                </thead>
                <DragDropTableBody move={move}>
                    {items.map((item, index, arr) => (
                        <DraggableRow item={item} index={index} key={index}>
                            <DraggableCell className="pl-0">
                                <FastField type="text" id={`${name}.${index}.id`} name={`${name}.${index}.id`} className={classNames('form-control',
                                    {error: get(form.errors, `${name}.${index}.id`) && get(form.touched, `${name}.${index}.id`)})} />
                                {get(form.errors, `${name}.${index}.id`) && get(form.touched, `${name}.${index}.id`) && (
                                    <Error reason={get(form.errors, `${name}.${index}.id.key`)} />
                                )}
                            </DraggableCell>
                            <DraggableCell>
                                <FastField type="text" id={`${name}.${index}.value`} name={`${name}.${index}.value`} className={classNames('form-control',
                                    {error: get(form.errors, `${name}.${index}.value`) && get(form.touched, `${name}.${index}.value`)})} />
                                {get(form.errors, `${name}.${index}.value`) && get(form.touched, `${name}.${index}.value`) && (
                                    <Error reason={get(form.errors, `${name}.${index}.value.key`)} />
                                )}
                            </DraggableCell>
                            <DraggableCell>
                                <img src={get(form.values, `${name}.${index}.url`)} className="img-fluid" />
                            </DraggableCell>
                            <DraggableCell>
                                <FastField name={`${name}.${index}.shuffle`}>
                                    {({field}) => (
                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" name={field.name} id={`${name}.${index}.shuffle`} className="custom-control-input"
                                                checked={field.value || false} onChange={field.onChange} />
                                            <label className="custom-control-label" htmlFor={`${name}.${index}.shuffle`}>&nbsp;</label>
                                        </div>
                                    )}
                                </FastField>
                            </DraggableCell>
                            <DraggableCell className="text-right">
                                {index > 0 && <UpButton move={move} index={index} />}
                                {index + 1 < arr.length && <DownButton move={move} index={index} />}
                                <MinusButton remove={remove} index={index} />
                            </DraggableCell>
                        </DraggableRow>
                    ))}
                </DragDropTableBody>
                <tfoot>
                    <tr>
                        <td colSpan="4" className="pl-0">
                            <button type="button" className="btn btn-outline-primary btn-sm" onClick={this.toggleModal}>
                                <FormattedMessage {...messages.media.button.chooseFromLibrary} />
                            </button>
                        </td>
                    </tr>
                </tfoot>
                <MediaGalleryModal isOpen={this.state.modalOpen} toggle={this.toggleModal} onSelect={this.handleSelect} />
            </table>
        );
    }
}

export default ImageChoiceType;
